const BROWSER = true;
const DEV = false;
export {
  BROWSER,
  DEV
};
//# sourceMappingURL=prod-browser.js.map
